// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2885":"c9dce26f","3620":"5b7b4d5f","9037":"2ffb3c5d","9542":"c9dce26f"}[chunkId] + ".chunk.css";
};